
import {
  Box, Button, Popover, Typography, useTheme, useMediaQuery, IconButton,
} from "@mui/material";
import React, { useState,useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateReservationGroup } from "../../store/slice/Addguest.slice";
import ShowMoreLessText from "./ShowMoreLessText";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import { useWidgetHeight } from "./widgetHeightContext"; // already imported above
import { UsePopoverPosition } from "../../hooks/UsePopoverPosition";

const ReservationGroup = ({ isOpen, handleClose, Ref }) => {
  const theme = useTheme();
  const [showMore, setShowMore] = useState(false);
  const { css }    = useSelector((store) => store?.widgetSettings);
  const restypeCss = css?.find((item) => item?.cssTabFieldsGroupName === "Reservation type")?.fields;
  const { reservationGroupData, reservGroup, languageWords } = useSelector((store) => store?.addGuest);
  const dispatch = useDispatch();
  const { onPopoverClose } = useWidgetHeight();
  const {
    matchesSm,
    anchorOriginVert,
    transformOriginVert,
    paperSx,
    mobileOverrideProps,
  } = UsePopoverPosition(Ref, isOpen, 400);
  return (
    <Popover
      open={isOpen} anchorEl={Ref?.current}
      onClose={() => { onPopoverClose(); handleClose(); }}
      anchorOrigin={{ vertical: anchorOriginVert, horizontal: "center" }}
      transformOrigin={{ vertical: transformOriginVert, horizontal: "center" }}
      {...mobileOverrideProps}        
      PaperProps={{
        sx: {
          ...paperSx,                
          backgroundColor: restypeCss?.ReservationTypesBackgoundColor,
        }
      }}
    >
      <Box sx={{
        backgroundColor: theme?.resType?.bgColor, p: 3,
        display: "flex", flexDirection: "column", gap: "1rem",
      }}>
        {reservationGroupData?.map((item, i) => {
          const isActiveItem = reservGroup?.idarrangementtype === item?.idarrangementtype;
          return (
            <Box
              key={i}
              sx={{
                display: "flex", gap: "0.5rem", p: 2,
                backgroundColor: isActiveItem ? theme?.resType?.itemBgActive : theme?.resType?.itemBgColor,
                border: `1px solid ${theme?.resType?.borderColor}`,
                color: isActiveItem ? theme?.resType?.textColorActive : theme?.resType?.itemTextColor,
                borderRadius: "8px", cursor: "pointer",
                "&:hover": { backgroundColor: theme?.resType?.itemBgHover, color: theme?.resType?.textHover },
              }}
              onClick={() => { dispatch(updateReservationGroup(item)); handleClose();  }}
            >
              <Box sx={{ width: "100%" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography sx={{ fontSize: "1.1rem", fontWeight: "600" }}>{item?.name}</Typography>
                  {!item?.info && (
                    <Button
                      variant="contained" size="small"
                      sx={{
                        backgroundColor: isActiveItem ? theme?.resType?.chooseBgActive : theme?.resType?.chooseBg,
                        color: isActiveItem ? theme?.resType?.chooseTextActive : theme?.resType?.chooseText,
                        "&:hover": { backgroundColor: theme?.resType?.chooseBgHover, color: theme?.resType?.chooseTextHover },
                        width: "60px", height: "30px", fontSize: "10px", borderRadius: "7px", ml: 1,
                      }}
                      onClick={(e) => { e.stopPropagation(); dispatch(updateReservationGroup(item));    onPopoverClose();  handleClose(); }}
                    >
                      {languageWords?.choose}
                    </Button>
                  )}
                </Box>
                {item?.info && (
                  <ShowMoreLessText
                    text={item?.info}
                    setIsShowMore={() => setShowMore((p) => !p)}
                    isShowMore={showMore}
                    showLess={languageWords?.Showless}
                    showMore={languageWords?.Showmore}
                  />
                )}
                {item?.info && (
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <IconButton
                      size="small"
                      sx={{
                        backgroundColor: isActiveItem ? theme?.resType?.chooseBgActive : theme?.resType?.chooseBg,
                        color: isActiveItem ? theme?.resType?.chooseTextActive : theme?.resType?.chooseText,
                        "&:hover": { backgroundColor: theme?.resType?.chooseBgHover, color: theme?.resType?.chooseTextHover },
                        borderRadius: "5px", ml: 1,
                      }}
                      onClick={() => { dispatch(updateReservationGroup(item));   onPopoverClose();  handleClose();   }}
                    >
                      <AddCircleTwoToneIcon />
                    </IconButton>
                  </Box>
                )}
              </Box>
            </Box>
          );
        })}
      </Box>
    </Popover>
  );
};

export { ReservationGroup };
export default ReservationGroup;
